module.exports = __webpack_public_path__ + "img/28.8e73fc59.jpg";